function csrfToken() {
    const match = /XSRF-TOKEN=([^;]+)/.exec(document.cookie);
    return match ? match[1] : "";
}

export default class Api {

    constructor(url) {
        this.baseUrl = url;
        this.authorization = null;
        this.cache = {};
    }

    async request(path, method, body) {
        if (!this.authorization) {
            throw new Error("Unauthorized");
        }
        const url = this.baseUrl + path;
        const options = {
            mode: "cors",
            credentials: "include",
            headers: { 
                "X-Requested-With": "XMLHttpRequest",
                "Authorization": this.authorization,
                "X-XSRF-TOKEN": csrfToken()
            }
        };
        if (method) {
            options.method = method;
        }
        if (body) {
            options.headers["Content-Type"] = "application/json"
            options.body = JSON.stringify(body);
        }
        const res = await fetch(url, options);
        if (!res.ok) {
            throw Error(`request failed: (${res.status}) ${res.statusText}`);
        }
        if (/application\/json/.test(res.headers.get("Content-Type"))) {
            return await res.json();
        }
        if (/text\/plain/.test(res.headers.get("Content-Type"))) {
            return await res.text();
        }
        const data = await res.blob();
        return data.size > 0 ? data : null;
    }

    async get(path) {
        return await this.request(path);
    }

    async post(path, data) {
        return await this.request(path, "post", data);
    }

    async login({username, password}) {
        this.authorization = "Basic " + btoa(username + ":" + password);
        return await this.get("login");
    }

    async logout() {
        try {
            return await this.post("logout");
        } catch (e) {
            console.log("logout failed", e);
        } finally {
            this.authorization = null;
        }
    }

    async getDisplayTypes() {
        if (!this.cache.displayTypes) {
            this.cache.displayTypes = await this.get("displaytype");
        }
        return this.cache.displayTypes;
    }

    async getDisplayFields() {
        if (!this.cache.displayFields) {
            const fields = {};
            const dtypes = await this.getDisplayTypes();
            for (const dt in dtypes) {
                for (const page of dtypes[dt].pages) {
                    for (const f of page.fields) {
                        if (f.name in fields) {
                            fields[f.name].push(f);
                        } else {
                            fields[f.name] = [f];
                        }
                    }
                }
            }
            this.cache.displayFields = fields;
        }
        return this.cache.displayFields;
    }

    async getDisplayPages() {
        const pages = [];
        const dtypes = await this.getDisplayTypes();
        for (const dtid in dtypes) {
            const dt = dtypes[dtid];
            for (let i = 0; i < dt.pages.length; i++) {
                if (i == pages.length) {
                    pages.push(dt.pages[i].name);
                }
            }
        }
        return pages;
    }

    async getLabel(id) {
        return await this.get(`label/${id}`);
    }

    async getProduct(id) {
        return await this.get(`product/${id}`);
    }

    async getProductByEan(ean) {
        return await this.get(`product?ean=${ean}`);
    }

    async getLocation(id) {
        return await this.get(`location/${id}`);
    }

    async sync(items) {
        return await this.post("sync", items);
    }

    async updateLabel(id) {
        return await this.post(`label/${id}/update`);
    }

    async status() {
        return await this.get("status");
    }

    async turnPage(page) {
        return await this.post(`page/${page}`);
    }
}



// WEBPACK FOOTER //
// ./src/api.js